import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { MessageService, Message } from '@app/_components/message';
import { AlertService, AuthenticationService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent } from 'primeng/api';

@Component({
    selector: 'app-message-list',
    templateUrl: './message-list.component.html',
    styleUrls: ['./message-list.component.css'],
    standalone: false
})
export class MessageListComponent implements OnInit
{
	datasource: Message[];
	message: Message;
	messages: Message[] = [];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	userStatusOptions: SelectItem[];

	columns: any[] = [
		{ field: 'messageId', header: 'Id' },
		{ field: 'createDate', header: 'Date' },
		{ field: 'toFirstName', header: 'First' },
		{ field: 'toLastName', header: 'Last' },
		{ field: 'toSubject', header: 'Subject' },
		{ field: 'messageStatus', header: 'Status' },
		{ field: 'messageType', header: 'Type' }
	];

	constructor(
		private authenticationService: AuthenticationService,
		private messageService: MessageService,
		private alertService: AlertService,
		private router: Router
	) { }


	ngOnInit()
	{

	}

	loadLazy(event: LazyLoadEvent)
	{
		try
		{
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.messageService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					data =>
					{
						console.log('users are: ' + JSON.stringify(data));
						this.datasource = data.data.messages;
						this.recordTotal = data.page.recordTotal;
						this.messages = data.data.messages;
					},
					error =>
					{
						console.log('USER LIST!: ' + JSON.stringify(error));
						this.alertService.error(error);
					},
					() =>
					{ this.loading = false; }
				);

			if (this.datasource)
			{
				this.messages = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error)
		{
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event)
	{
		try
		{
			// use this for adding query params
			// this.router.navigate(['user-edit'], { queryParams: { userId: event.data.userId } });
			this.router.navigate(['message-view', event.data.messageId]);
		} catch (error)
		{
			console.log('onRowSelect(' + event + ')' + error);
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
